import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Lock = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    className={className}
    onClick={onClick}
    ref={ref}
    height={22}
    width={22}
  >
    <path
      fill="currentColor"
      d="M400 224h-24v-72a152 152 0 0 0-304 0v72H48c-26 0-48 22-48 48v192c0 27 22 48 48 48h352c27 0 48-21 48-48V272c0-26-21-48-48-48zm-104 0H152v-72a72 72 0 0 1 144 0v72z"
    />
  </svg>
));
